export var FakeParticipant;
(function (FakeParticipant) {
    FakeParticipant["Agent"] = "Agent";
    FakeParticipant["LocalScreenShare"] = "LocalScreenShare";
    FakeParticipant["RemoteScreenShare"] = "RemoteScreenShare";
    FakeParticipant["SharedVideo"] = "SharedVideo";
    FakeParticipant["Whiteboard"] = "Whiteboard";
})(FakeParticipant || (FakeParticipant = {}));
